import { reactive } from 'vue';
import { createStepUpQueue } from './mfa';

/**
 * step-up 창 상태. App.vue 의 StepUpModal 이 이 값을 보고 뜬다.
 * axios 인터셉터가 requestStepUp(purpose) 를 부르면 창이 열리고, 통과하면 true·닫으면 false 로 끝난다.
 */
export const stepUpState = reactive({
  visible: false,
  purpose: 'LOGIN',
  resolve: null,
});

export const requestStepUp = createStepUpQueue(
  (purpose) =>
    new Promise((resolve) => {
      Object.assign(stepUpState, { visible: true, purpose, resolve });
    })
);

export const finishStepUp = (passed) => {
  const { resolve } = stepUpState;
  Object.assign(stepUpState, { visible: false, resolve: null });
  if (resolve) resolve(passed);
};
